import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverLastPlaceResponseDTO
} from '../../interfaces/apiInterfaces';

export class GetDriverLastPlaceCommand extends IRequestCommand<
  Array<IGetDriverLastPlace>,
  ErrorDetails,
  IGetDriverLastPlaceCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/lastPlace?state={state}';

  public override setParameters(parameters: IGetDriverLastPlaceCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this.commandUrl.replace(
      '{state}',
      parameters.state.toString()
    )
  }
}

export interface IGetDriverLastPlaceCommandParameters
  extends ICommandParameters {
  carrierUserId: string;
  state: string
}

export interface IGetDriverLastPlace
  extends ICommandResponse,
  DriverLastPlaceResponseDTO { }
